module.exports = __webpack_public_path__ + "static/media/amex.3f2a8aa3.svg";